module.exports = __webpack_public_path__ + "img/step_5.d691d410.webp";